import React, { useState, useEffect, useRef } from "react";
import "./App.css";
import CryptoPopup from "./components/CryptoPopup";
import { ensureVisitorRecorded } from "./utils/funzoneVisitor";

// Fun games only – no casino imagery, pure play
const GAMES = [
  {
    name: "Cai Shen's Gifts",
    icon: "🧧",
    url: "https://prod2.platipusgaming.com/onlinecasino/GetGames/GetGameDemo?demo=true&gameconfig=caishensgifts&lobby=https://platipusgaming.com/en",
  },
  {
    name: "Baccarat",
    icon: "🎴",
    url: "https://prod2.platipusgaming.com/onlinecasino/GetGames/GetGameDemo?demo=true&gameconfig=baccaratvip&lobby=https://platipusgaming.com/en",
  },
  {
    name: "Blackjack",
    icon: "🃏",
    url: "https://prod2.platipusgaming.com/onlinecasino/GetGames/GetGameDemo?demo=true&gameconfig=blackjack&lobby=https://platipusgaming.com/en",
  },
  {
    name: "Roulette",
    icon: "🎯",
    url: "https://prod2.platipusgaming.com/onlinecasino/GetGames/GetGameDemo?demo=true&gameconfig=rouletteeuropean&lobby=https://platipusgaming.com/en",
  },
  {
    name: "Plinko",
    icon: "🎲",
    url: "https://prod2.platipusgaming.com/onlinecasino/GetGames/GetGameDemo?demo=true&gameconfig=plinko&lobby=https://platipusgaming.com/en",
  },
  {
    name: "Diamond Hunt",
    icon: "💎",
    url: "https://prod2.platipusgaming.com/onlinecasino/GetGames/GetGameDemo?demo=true&gameconfig=diamondhunt&lobby=https://platipusgaming.com/en",
  },
  {
    name: "Crash",
    icon: "🚀",
    url: "https://prod2.platipusgaming.com/onlinecasino/getgames/getgamedemo?demo=true&gameconfig=airboss",
  },
  {
    name: "Chicken Crossing",
    icon: "🐔",
    url: "https://platipusgaming.cloud/cockadoodlecash/276/index.html?demo=true&key=89f8305ba38f42b98d65eade7a5517fa&version=276&lang=&games_url=https%3A%2F%2Fplatipusgaming.cloud%2F&server_tournament=https%3A%2F%2Fgamification-client-api.platipusgaming.com%2Fgamification%2F&server=https%3A%2F%2Fprod2.platipusgaming.com%2F&lobby=https%3A%2F%2Fplatipusgaming.com%2Fen&",
  },
  {
    name: "Texas Hold'em",
    icon: "♠️",
    url: "https://prod2.platipusgaming.com/onlinecasino/GetGames/GetGameDemo?demo=true&gameconfig=texasholdem&lobby=https://platipusgaming.com/en",
  },
  {
    name: "Caribbean Poker",
    icon: "🃏",
    url: "https://prod2.platipusgaming.com/onlinecasino/GetGames/GetGameDemo?demo=true&gameconfig=caribbeanclubpoker&lobby=https://platipusgaming.com/en",
  },
];

const MAIN_WEBSITE = "https://www.rushplay.win/";
const TIME_THRESHOLD = 5 * 60 * 1000; // 5 minutes

function App() {
  const [currentGame, setCurrentGame] = useState(null);
  const [showCryptoPopup, setShowCryptoPopup] = useState(false);

  const startTimeRef = useRef(Date.now());
  const timerRef = useRef(null);
  const lastPopupTimeRef = useRef(0);

  useEffect(() => {
    ensureVisitorRecorded();
  }, []);

  useEffect(() => {
    timerRef.current = setInterval(() => {
      const elapsed = Date.now() - startTimeRef.current;
      const timeSinceLastPopup = elapsed - lastPopupTimeRef.current;
      if (timeSinceLastPopup >= TIME_THRESHOLD) {
        setShowCryptoPopup(true);
        lastPopupTimeRef.current = elapsed;
      }
    }, 1000);
    return () => {
      if (timerRef.current) clearInterval(timerRef.current);
    };
  }, []);

  const handleGameClick = (game) => setCurrentGame(game);
  const handleBackFromGame = () => setCurrentGame(null);

  const handleExploreMore = () => {
    window.open(MAIN_WEBSITE, "_blank", "noopener,noreferrer");
  };

  const handleExploreNo = () => {
    setShowCryptoPopup(false);
  };

  return (
    <div className="app-container">
      {!currentGame ? (
        <div className="container">
          {/* <header className="header">
            <img src="/logo.png" alt="FunZone" className="logo" />
            <div className="tagline">FUNZONE</div>
          </header> */}

          <section className="hero-section">
            <h1 className="hero-title">Pure fun games</h1>
            <p className="hero-subtitle">
              No money, no gambling — just free games for fun. Pick one and
              play.
            </p>
          </section>

          <section className="games-section">
            <h2 className="section-title">Pick a game</h2>
            <div className="games-grid">
              {GAMES.map((game, index) => (
                <button
                  key={index}
                  type="button"
                  className="game-card"
                  onClick={() => handleGameClick(game)}>
                  <span className="game-card-icon" aria-hidden>
                    {game.icon}
                  </span>
                  <span className="game-name">{game.name}</span>
                </button>
              ))}
            </div>
          </section>

          <footer className="footer">
            <p>For fun only • No real money • 18+</p>
          </footer>
        </div>
      ) : (
        <div className="game-view active">
          <div className="game-header">
            <button
              type="button"
              className="game-back-btn"
              onClick={handleBackFromGame}>
              ← Back to games
            </button>
            <div className="game-title-display">{currentGame.name}</div>
            <div className="game-header-spacer" />
          </div>
          <iframe
            className="game-iframe"
            src={currentGame.url}
            title={currentGame.name}
            allowFullScreen
          />
        </div>
      )}

      <CryptoPopup
        show={showCryptoPopup}
        onYes={handleExploreMore}
        onNo={handleExploreNo}
      />
    </div>
  );
}

export default App;
